var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n    "+_vm._s(_vm.strings["title"])+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.strings["description"])+"\n  ")]),_vm._v(" "),_c('button',{on:{"click":_vm.nextLevel}},[_vm._v("\n    "+_vm._s(_vm.strings["startButton"])+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0347fd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 27
// module chunks = 0